/** The list of languages that are translated */
const translations = [
	'fr'
];

export default translations;
